import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CssBaseline from '@material-ui/core/CssBaseline'
import LockPersonRoundedIcon from '@mui/icons-material/LockOpenRounded'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import ListItem from '@material-ui/core/ListItem'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import { makeStyles } from '@material-ui/core/styles'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Apis } from '../../Apis/Apis'
import { AuthToken } from 'app/auth/AuthToken'
import Alert from '@mui/material/Alert'
const drawerWidth = 240

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    drawer: {
        [theme.breakpoints.up('sm')]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },

    toolbar: theme.mixins.toolbar,
    drawerPaper: {
        width: drawerWidth,
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
}))

function Password(props) {
    const [message, setMessage] = useState()
    const classes = useStyles()
    const navigate = useNavigate()

    const [alldata, setAllData] = useState({
        currentpassword: '',
        newpassword: '',
        cnewpassword: '',
    })

    const handleChange = (e) => {
        setAllData({
            ...alldata,
            [e.target.name]: e.target.value,
        })
    }

    // let headers =

    const Body = {
        currentPass: alldata.currentpassword,
        newPass: alldata.cnewpassword,
    }
    const handleSubmit = () => {
        if (!alldata.currentpassword) {
            setMessage('Current password is required !')
        } else {
            if (!alldata.newpassword) {
                setMessage('New password is required !')
            } else {
                if (!alldata.cnewpassword) {
                    setMessage('Confirm password is required !')
                } else {
                    console.log('fasfasfa')
                    axios
                        .put(`${Apis.setPassword}`, Body, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    'accessToken'
                                )}`,
                            },
                        })
                        .then((res) => {
                            console.log(res)

                            setMessage([
                                res?.data?.message ||
                                    'Password reset successfully',
                                res?.data?.code,
                            ])

                            setTimeout(() => {
                                navigate('/dashboard/approvedAppointments')
                            }, 2000)
                        })
                        .catch((err) => {
                            console.log('Error in password change api', err)
                            setMessage('Please enter right password')
                        })
                }
            }
        }
    }

    const testData = () => {
        console.log(AuthToken.accessToken)
        console.log(localStorage.getItem('accessToken'))
    }
    return (
        <div className={classes.root}>
            {message ? (
                <Alert
                    severity={message[1] === 200 ? 'success' : 'error'}
                    sx={{ position: 'fixed', width: '80%' }}
                >
                    {message.length === 2 ? message[0] : message}
                </Alert>
            ) : (
                ''
            )}
            <CssBaseline />
            <div>
                <div className={classes.toolbar} />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 3,
                        width: { sm: `calc(100%   )` },
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={2.5}
                            md={2.5}
                            sx={{ borderRight: 'solid gray', width: '25rem' }}
                        >
                            <Box sx={{ paddingBottom: 3 }}>
                                <Link
                                    to={'/dashboard/user-profile'}
                                    style={{
                                        textDecoration: 'none',
                                        color: 'black',
                                    }}
                                >
                                    <PersonOutlineIcon />
                                    Basic Information
                                </Link>
                            </Box>
                            <Box sx={{ paddingBottom: 3 }}>
                                <Link
                                    to={'/dashboard/user-password'}
                                    style={{
                                        textDecoration: 'none',
                                        color: 'black',
                                    }}
                                >
                                    <LockPersonRoundedIcon onClick={testData} />
                                    Password
                                </Link>
                            </Box>
                        </Grid>

                        <Grid item xs={8} md={8}>
                            <Grid item></Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={6} md={6}>
                                    <Box
                                        component="form"
                                        sx={{
                                            '& > :not(style)': {
                                                m: 1,
                                                width: '80%',
                                            },
                                        }}
                                        noValidate
                                        autoComplete="off"
                                    >
                                        <TextField
                                            id="outlined-basic"
                                            label="Current Password"
                                            name="currentpassword"
                                            onChange={handleChange}
                                            variant="outlined"
                                        />
                                        <TextField
                                            id="outlined-basic"
                                            label="New Password"
                                            variant="outlined"
                                            name="newpassword"
                                            onChange={handleChange}
                                        />
                                        <TextField
                                            id="outlined-basic"
                                            label="Confirm New Password"
                                            variant="outlined"
                                            name="cnewpassword"
                                            onChange={handleChange}
                                        />
                                    </Box>
                                </Grid>

                                <Grid item xs={6} md={6}>
                                    <Box
                                        component="form"
                                        sx={{
                                            '& > :not(style)': {
                                                m: 1,
                                                width: '80%',
                                            },
                                        }}
                                        noValidate
                                        autoComplete="off"
                                    >
                                        <ListItem>
                                            Password requirements:
                                        </ListItem>
                                        <ListItem>
                                            Ensure that these requirements are
                                            met:{' '}
                                        </ListItem>
                                        <div className="m-4">
                                            <li>
                                                Minimum 8 characters long - the
                                                more, the better
                                            </li>
                                            <li>
                                                At least one lowercase character
                                            </li>
                                            <li>
                                                At least one uppercase character
                                            </li>
                                            <li>
                                                At least one number, symbole, or
                                                whitespace character
                                            </li>
                                        </div>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Button
                                variant="contained"
                                className="m-2"
                                onClick={handleSubmit}
                            >
                                {' '}
                                Save Changes
                            </Button>

                            <Button
                                onClick={() => {
                                    navigate('/dashboard/approvedAppointments')
                                }}
                                variant="contained"
                                className="m-2"
                            >
                                {' '}
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </div>
        </div>
    )
}

Password.propTypes = {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window: PropTypes.func,
}

export default Password
